import React, { useState } from "react";
import { Form, Input, Divider, Modal } from "antd";
import { SearchOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { get } from 'lodash';

const TextInputSelect = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  backingIdField,
  label,
  formItemLayout,
  placeholder,
  readOnly,
  SearchControl,
  ViewControl,
  showDelete,
  searchModalTitle,
  viewModalTitle,
  modalwidth,
  onSelectionChanged,
  dependentFieldName
}) => {
  const [internalState, setValue] = useState({ view_visible: false, select_visible: false });

  const showViewModal = () => {
    setValue({ view_visible: true, select_visible: false });
  };
  const showSelectModal = () => {
    setValue({ view_visible: false, select_visible: true });
  };
  const handleCancelModal = () => {
    setValue({ view_visible: false, select_visible: false });
  };
  const onDoubleClick = () => {
     handleSelectModalOk();
  }

  const handleSelectModalOk = () => {
    if (internalState.selectedId && backingIdField) {
      setFieldValue(backingIdField, internalState.selectedId, false)
      if (onSelectionChanged) {
        onSelectionChanged(internalState.selectedId, internalState.selectedDisplay, internalState.dependentFieldValue)
      }
      if (dependentFieldName) { //voor clearen van gerelateerd veld, of vullen...(cascading fields)
        if (internalState.dependentFieldValue !== null) {
          setFieldValue(dependentFieldName, internalState.dependentFieldValue, false);
        } else {
          setFieldValue(dependentFieldName, null, false);
        }
      }
    }
    if (internalState.selectedDisplay) {
      setFieldValue(name, internalState.selectedDisplay, false);
      setFieldTouched(name);
    }
    setValue({ view_visible: false, select_visible: false });
  };
  const onSelected = (id, value, optvalue) => {
    //console.log('clicked...',id, value, optvalue);
    let oldstate = internalState;
    oldstate.selectedId = id;
    oldstate.selectedDisplay = value;
    oldstate.dependentFieldValue = optvalue;
    setValue(oldstate);
  };
  const bgcolor = readOnly ? '#ebebeb' : '#ffffff';
  return (
    <>
      <Form.Item label={label} {...formItemLayout}
        hasFeedback={!!get(errors, name)}
        validateStatus={get(errors, name) && "error"}
        help={get(errors, name)}
      >
        <Input onKeyDown={showSelectModal} className={SearchControl ? "bnpicker" : ""}
          onPressEnter={showSelectModal}
          placeholder={placeholder}
          value={get(values, name)}
          onChange={event => setFieldValue(name, event.target.value)}
          onBlur={() => setFieldTouched(name)}
          readOnly={readOnly} 
          //disabled={readOnly}
          suffix={<>
            {SearchControl && SearchControl.type !== "span" &&
              <SearchOutlined onClick={showSelectModal} />
            }
            {SearchControl && ViewControl &&
              <Divider type="vertical" />
            }
            {ViewControl &&
              <EyeOutlined onClick={showViewModal} />
            }
            {(SearchControl || ViewControl) && showDelete &&
              < Divider type="vertical" />
            }
            {showDelete &&
              <DeleteOutlined onClick={() => {
                setFieldValue(name, '', false);
                backingIdField ? setFieldValue(backingIdField, '', false) : console.log('no backing field');
              }} />
            }
          </>}
        />
      </Form.Item>
      {ViewControl &&
        <Modal
          title={viewModalTitle ? viewModalTitle : 'Details'} width={modalwidth}
          open={internalState.view_visible}
          onCancel={handleCancelModal}
          onOk={handleCancelModal}
          destroyOnHidden={true}
        >
          {ViewControl(values[backingIdField])}
        </Modal>
      }
      {SearchControl &&
        <Modal
          title={searchModalTitle ? searchModalTitle : 'Selecteer item'} width={modalwidth}
          open={internalState.select_visible}
          onCancel={handleCancelModal}
          onOk={handleSelectModalOk}
          destroyOnHidden={true}
        >
          {SearchControl(onSelected, onDoubleClick)}
        </Modal>
      }
    </>
  )
};

export default TextInputSelect;
